import React from 'react';
import { AlertCircle, Check, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { EstadoGuardado } from '../types';

interface IndicadorGuardadoProps {
  estado: EstadoGuardado;
  onReintentar?: () => void;
}

/**
 * Estado del autoguardado: guardando, guardado o error con opción de reintentar.
 */
export const IndicadorGuardado: React.FC<IndicadorGuardadoProps> = ({
  estado,
  onReintentar,
}) => {
  if (estado === 'idle') return null;

  if (estado === 'guardando') {
    return (
      <span
        role="status"
        className="flex items-center gap-1.5 text-sm text-muted-foreground"
      >
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
        Guardando…
      </span>
    );
  }

  if (estado === 'guardado') {
    return (
      <span role="status" className="flex items-center gap-1.5 text-sm text-green-600">
        <Check className="h-3.5 w-3.5" />
        Guardado
      </span>
    );
  }

  return (
    <span role="alert" className="flex items-center gap-1.5 text-sm text-destructive">
      <AlertCircle className="h-3.5 w-3.5" />
      Error al guardar
      {onReintentar && (
        <Button
          size="sm"
          variant="ghost"
          className="h-6 px-2 text-destructive hover:text-destructive"
          onClick={onReintentar}
        >
          Reintentar
        </Button>
      )}
    </span>
  );
};
